/* tslint:disable:indent */
export class Website {

	public id: number;
	public name: string;
	public url: string;
	public active: boolean;
	public linkedPromotion: number;
	public linkedPromotionName: string;

	constructor(id: number, name: string, url: string, active: boolean, linkedPromotion: number, linkedPromotionName: string) {
		this.id = id;
		this.name = name;
		this.url = url;
		this.active = active;
		this.linkedPromotion = linkedPromotion;
		this.linkedPromotionName = linkedPromotionName;
	}

}




